import { jsxs as E, jsx as s } from "react/jsx-runtime";
import { useRef as L, useCallback as j, useEffect as C, forwardRef as M } from "react";
import { L as P } from "../index-CeQ14xPc.js";
import { c as W } from "../clsx-OuTLNxxd.js";
import { B as x } from "../Button-CNdjOPcY.js";
import '../Dialog.css';const X = "_closeButton_22a0b_32", Y = "_dialog_22a0b_36", $ = "_hasBackdrop_22a0b_52", z = "_isFullScreen_22a0b_55", q = "_closeButtonWrapper_22a0b_64", A = "_dialogWrapper_22a0b_77", G = "_panel_22a0b_91", a = {
  closeButton: X,
  dialog: Y,
  hasBackdrop: $,
  isFullScreen: z,
  closeButtonWrapper: q,
  dialogWrapper: A,
  panel: G
}, N = ({
  children: t,
  className: r,
  hasBackdrop: n = !0,
  isFullScreen: w = !1,
  isOpen: e = !1,
  setIsOpen: i,
  shouldCloseOnClickOutside: u = !0,
  title: p,
  triggerRef: l,
  ...y
}) => {
  const c = L(null), d = j(
    (o) => {
      var b, k, g;
      if (!u)
        return;
      const D = (b = c.current) == null ? void 0 : b.getBoundingClientRect(), { bottom: m = 0, left: _ = 0, right: f = 0, top: B = 0 } = D || {};
      if (B === 0 && m === 0 && _ === 0 && f === 0)
        return;
      const F = o.clientY < B || o.clientY > m || o.clientX < _ || o.clientX > f, h = ((k = l == null ? void 0 : l.current) == null ? void 0 : k.isConnected) ?? !1, S = h && ((g = l == null ? void 0 : l.current) == null ? void 0 : g.contains(o == null ? void 0 : o.target)), T = o.target === c.current;
      e && (T || F && !S && h) && i(!1);
    },
    [e, u, i, l]
  );
  return C(() => {
    c.current && (e ? c.current.showModal() : c.current.close());
  }, [c, e]), C(() => {
    if (!(typeof window > "u"))
      return document.addEventListener("click", d), () => {
        document.removeEventListener("click", d);
      };
  }, [d]), /* @__PURE__ */ E(
    "dialog",
    {
      "aria-label": `${p}-modal`,
      className: W(
        a.dialog,
        { [a.hasBackdrop]: n },
        { [a.isFullScreen]: w },
        r
      ),
      "data-cxy-name": "dialog",
      id: "cxy-dialog",
      ref: c,
      ...y,
      children: [
        /* @__PURE__ */ s("div", { className: a.closeButtonWrapper, children: /* @__PURE__ */ s(
          x,
          {
            "aria-label": `Close ${p} Modal`,
            className: a.closeButton,
            "data-testid": "close-button",
            onClick: () => i(!1),
            variant: "ghost",
            children: /* @__PURE__ */ s(P, { size: "xl" })
          }
        ) }),
        /* @__PURE__ */ s("div", { className: a.dialogWrapper, children: t })
      ]
    }
  );
}, H = ({ children: t, className: r, ...n }) => /* @__PURE__ */ s("section", { className: W(a.panel, r), ...n, children: /* @__PURE__ */ s("div", { className: a.panelWrapper, children: t }) }), J = M(({ children: t, ...r }, n) => /* @__PURE__ */ s(x, { ref: n, variant: "ghost", ...r, children: t }));
N.Panel = H;
N.Trigger = J;
export {
  N as Dialog
};
